import {
  BannerData,
  CallToActionData,
  FooterData,
  HeaderData,
  HeroData,
  PricingData,
  PricingTier,
  ProductShowcaseData,
  TestimonialsData,
} from "@/types/types";

// src/lib/constants.ts
// Removed duplicate headerData declaration

// Static data
export const bannerData: BannerData = {
  title: "Streamline your workflow and boost your productivity",
  link: {
    name: "Get started for free",
    href: "#",
  },
};

export const headerData: HeaderData = {
  headerLinks: [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "How it Works", href: "/how-it-works" },
    { name: "Contact us", href: "mailto:support@timelyyy.com" },
  ],
  cta: "Book Now",
};


export const heroData: HeroData = {
  tag: "Version 2.0 is here",
  title: "Pathway to productivity",
  description:
    "Celebrate the joy of accomplishment with an app designed to track your progress, motivate your efforts, and celebrate your successes.",
  primaryButton: "Get for free",
  secondaryButton: "Learn more",
};

export const productShowcaseData: ProductShowcaseData = {
  tag: "Teams & Analytics",
  title: "Effortlessly manage WhatsApp operations and commerce",
  description:
    "Easily manage and scale your operations on WhatsApp with a single team inbox to manage all customer conversations across all customers",
};

export const pricingData: PricingData = {
  title: "Pricing",
  description:
    "Free forever. Upgrade for unlimited tasks, better security, and exclusive features.",
  currency: "$",
  billingPeriod: "/month",
};

export const testimonialsData: TestimonialsData = {
  tag: "Testimonials",
  title: "What our users say",
  description:
    "From intuitive design to powerful features, our app has become an essential tool for users around the world.",
};

export const callToActionData: CallToActionData = {
  title: "Sign up for free today",
  description:
    "Celebrate the joy of accomplishment with an app designed to track your progress and motivate your efforts.",
  primaryButton: { name: "Get for free", href: "#" },
  secondaryButton: { name: "Learn more", href: "#" },
};

export const footerData: FooterData = {
  footerLinks: [
    { name: "About", href: "#" },
    { name: "Features", href: "#" },
    { name: "Customers", href: "#" },
    { name: "Updates", href: "#" },
    { name: "Help", href: "#" },
  ],
  copyRight: "2024 Your Company, Inc. All rights reserved.",
};

// Pricing tier data
export const pricingTiers: PricingTier[] = [
  {
    title: "Free",
    monthlyPrice: 0,
    buttonText: "Get started for free",
    popular: false,
    inverse: false,
    features: [
      "Up to 5 project members",
      "Unlimited tasks and projects",
      "2GB storage",
      "Integrations",
      "Basic support",
    ],
  },
  {
    title: "Pro",
    monthlyPrice: 9,
    buttonText: "Sign up now",
    popular: true,
    inverse: true,
    features: [
      "Up to 50 project members",
      "Unlimited tasks and projects",
      "50GB storage",
      "Integrations",
      "Priority support",
      "Advanced support",
      "Export support",
    ],
  },
  {
    title: "Business",
    monthlyPrice: 19,
    buttonText: "Sign up now",
    popular: false,
    inverse: false,
    features: [
      "Up to 5 project members",
      "Unlimited tasks and projects",
      "200GB storage",
      "Integrations",
      "Dedicated account manager",
      "Custom fields",
      "Advanced analytics",
      "Export capabilities",
      "API access",
      "Advanced security features",
    ],
  },
];
